export interface Restaurant {
  address: string,
  business_additional_information: string,
  coords: Coords,
  days_show_slots_takeaway_delivery: number|null,
  delivery_cost: number,
  delivery_measure_cost: number,
  delivery_measure_type: DeliveryMeasureType,
  free_delivery_minimum_amount: number,
  id: string,
  logo: {
    url: string,
    fullPath: string,
  };
  max_delivery_distance: number,
  max_order_approvement_waiting_time: number | null,
  max_take_away_delivery_slots: MaxTakeAwaySeliverySlots|null,
  min_range_free: number,
  minimum_external_order_amount: number,
  name: string,  
  take_away_delivery_interval: number|null,
}

export interface MaxTakeAwaySeliverySlots {
  max_take_away: number,
  max_delivery: number,
}

export interface Coords {
  lat: number,
  lng: number
}

export enum DeliveryMeasureType {
    KM= 'km',
    DEFAULT= 'fixed',
}